const REV = '2026-04-15';

/**
 * Binds Klaviyo newsletter forms inside a DOM root.
 * @param {ParentNode} root - Root node to scan for forms.
 */
function initKlaviyoNewsletterForms(root = document) {
  root.querySelectorAll('[data-klaviyo-newsletter]:not([data-klaviyo-bound])').forEach((form) => {
    form.dataset.klaviyoBound = 'true';

    const feedback = form.querySelector('.newsletter-klaviyo-form__feedback');
    const emailInput = form.querySelector('input[type="email"]');
    const formRow = form.querySelector('.form-row');

    if (!feedback || !emailInput) {
      return;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const { companyId, listId, market, successMessage, errorMessage } = form.dataset;
      const submitButton = form.querySelector('[type="submit"]');

      submitButton?.toggleAttribute('disabled', true);
      emailInput.toggleAttribute('disabled', true);

      const profileAttributes = { email: emailInput.value.trim() };

      if (market) {
        profileAttributes.properties = { shopify_market: market };
      }

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            revision: REV,
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttributes,
                  },
                },
              },
              relationships: {
                list: { data: { type: 'list', id: listId } },
              },
            },
          }),
        });

        if (!response.ok) {
          throw new Error('Klaviyo subscription failed');
        }

        formRow?.setAttribute('hidden', '');
        feedback.hidden = false;
        feedback.className = 'newsletter-klaviyo-form__feedback banner banner--success text-center';
        feedback.textContent = successMessage;
        emailInput.value = '';
      } catch {
        feedback.hidden = false;
        feedback.className = 'newsletter-klaviyo-form__feedback banner banner--error text-center';
        feedback.textContent = errorMessage;
      } finally {
        submitButton?.toggleAttribute('disabled', false);
        emailInput.toggleAttribute('disabled', false);
      }
    });
  });
}

initKlaviyoNewsletterForms();
document.addEventListener('shopify:section:load', (event) => initKlaviyoNewsletterForms(event.target));
